import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SpotlitePreloadStrategy } from './utils/spotlite-preload.strategy';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'confirm-reservation',
    loadChildren: () => import('./confirm-reservation/confirm-reservation.module').then( m => m.ConfirmReservationPageModule)
  },
  {
    path: 'venue',
    loadChildren: () => import('./venue/venue.module').then( m => m.VenuePageModule)
  },
  {
    path: 'manage-reservation',
    loadChildren: () => import('./manage-reservation/manage-reservation.module').then( m => m.ManageReservationPageModule)
  },
  {
    path: 'accept-invite',
    loadChildren: () => import('./accept-invite/accept-invite.module').then( m => m.AcceptInvitePageModule)
  },
  {
    path: 'membership',
    loadChildren: () => import('./public-membership/public-membership.module').then( m => m.PublicMembershipPageModule)
  },
  {
    path: 'complete-membership',
    loadChildren: () => import('./public-complete-membership/public-complete-membership.module').then( m => m.PublicCompleteMembershipModule)
  },
  {
    // EAG-2934: the card-request link emailed to a corporate membership's account Owner.
    path: 'account-billing',
    loadChildren: () => import('./public-account-billing/public-account-billing.module').then( m => m.PublicAccountBillingPageModule)
  },
  {
    path: 'membership-success',
    loadChildren: () => import('./membership-success/membership-success.module').then( m => m.MembershipSuccessPageModule)
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then( m => m.TermsAndConditionsPageModule)
  },
  {
    path: 'survey/:token',
    loadChildren: () => import('./pages/follow-up-survey/follow-up-survey.module').then( m => m.FollowUpSurveyPageModule)
  },
  {
    // EAG-3114: the unsubscribe link in campaign emails (marketing email only).
    path: 'unsubscribe/:token',
    loadChildren: () => import('./pages/marketing-unsubscribe/marketing-unsubscribe.module').then( m => m.MarketingUnsubscribePageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'giftcard/purchase',
    loadChildren: () => import('./giftcard-purchase/giftcard-purchase.module').then( m => m.GiftcardPurchasePageModule)
  },
  {
    path: 'reservation-submission/success',
    loadChildren: () => import('./reservation-submission/success/success.module').then( m => m.SuccessPageModule)
  },
  {
    path: 'end-user-terms',
    loadChildren: () => import('./end-user-terms/end-user-terms.module').then( m => m.EndUserTermsPageModule)
  },
  {
    path: 'league',
    loadChildren: () => import('./league-pages/league/league.module').then( m => m.LeaguePageModule)
  },
  {
    path: 'league/registration',
    loadChildren: () => import('./league-pages/league-registration/league-registration.module').then( m => m.LeagueRegistrationPageModule)
  },
  {
    path: 'league/leaderboard',
    loadChildren: () => import('./league-pages/league-leaderboard/league-leaderboard.module').then( m => m.LeagueLeaderboardPageModule)
  },
  {
    path: 'league/schedule',
    loadChildren: () => import('./league-pages/league-schedule/league-schedule.module').then( m => m.LeagueSchedulePageModule)
  },
  {
    path: 'league-registration-successful',
    loadChildren: () => import('./league-pages/league-registration-successful/league-registration-successful.module').then( m => m.LeagueRegistrationSuccessfulPageModule)
  },
  {
    path: 'league/referral-code/:rc',
    loadChildren: () => import('./league-pages/league-referral-code/league-referral-code.module').then( m => m.LeagueReferralCodePageModule)
  },
  {
    path: 'redeem-awards',
    loadChildren: () => import('./league-pages/league-referral-code/redeem-awards/redeem-rewards.module').then( m => m.RedeemRewardsPageModule)
  },
  {
    path: 'view-referrals',
    loadChildren: () => import('./league-pages/league-referral-code/view-referrals/view-referrals.module').then( m => m.ViewReferralsPageModule)
  },
  {
    path: 'render-campaign/:campaignSlug',
    loadChildren: () => import('./in-venue/render-campaign/render-campaign.module').then( m => m.RenderCampaignPageModule)
  },
  {
    path: 'in-bay-management',
    loadChildren: () => import('./in-bay-management/in-bay-management.module').then( m => m.InBayManagementPageModule)
  },
  {
    path: 'walk-up',
    loadChildren: () => import('./walk-up-bays/walk-up-bays.module').then( m => m.WalkUpBaysPageModule)
  },
  //HACK commenting out in favor of blank-timer for now @dirk 4/10/25
  {
    path: 'in-bay/timer/new',
    loadChildren: () => import('./in-bay/timer/timer.module').then( m => m.TimerPageModule)
  },
  {
    path: 'in-bay/timer',
    redirectTo: 'in-bay/blank-timer',
    //pathMatch: 'full'
  },
  {
    path: 'in-bay/blank-timer',
    loadChildren: () => import('./in-bay/blank-timer/blank-timer.module').then( m => m.BlankTimerPageModule)
  },
  {
    path: 'kiosk',
    loadChildren: () => import('./kiosk/kiosk.module').then( m => m.KioskPageModule)
  },
  {
    path: 'tee-time/booking',
    loadChildren: () => import('./pages/tee-time-booking-payment/tee-time-booking-payment.module').then( m => m.TeeTimeBookingPaymentPageModule)
  },
  {
    path: 'tee-time/manage-booking',
    loadChildren: () => import('./pages/tee-time-manage-booking/tee-time-manage-booking.module').then( m => m.TeeTimeManageBookingPageModule)
  },
  {
    path: 'tee-time/payment-processing',
    loadChildren: () => import('./pages/payment-processing/payment-processing.module').then( m => m.PaymentProcessingPageModule)
  },
  {
    path: 'tee-time/cancellation-confirmed',
    loadChildren: () => import('./pages/cancellation-confirmed/cancellation-confirmed.module').then( m => m.CancellationConfirmedPageModule)
  },
  {
    path: 'tee-time/invalid-token',
    loadChildren: () => import('./pages/invalid-token/invalid-token.module').then( m => m.InvalidTokenPageModule)
  }
  ,
  {
    path: 'loyalty',
    loadChildren: () => import('./loyalty/loyalty.module').then(m => m.LoyaltyPageModule)
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [
    // SpotlitePreloadStrategy, not PreloadAllModules: preloading all ~30 lazy
    // routes in parallel the moment the first route resolved was what produced
    // "Importing a module script failed." on guest phones (Sentry SPOTLITE-C8).
    RouterModule.forRoot(routes, { preloadingStrategy: SpotlitePreloadStrategy })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
